import React, { useCallback } from 'react';
import { Container, Col, Row, Button, Image } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { Haptics, ImpactStyle } from '@capacitor/haptics';
import './KingdomButtonPage.css';

const KINGDOMS_DATA = [
  { name: "England",          flag: "/englandFlag.png",          path: "/uk/england" },
  { name: "Scotland",         flag: "/scotlandFlag.png",         path: "/uk/scotland" },
  { name: "Wales",            flag: "/walesFlag.png",            path: "/uk/wales" },
  { name: "Northern Ireland", flag: "/northernIrelandFlag.png",  path: "/uk/northernireland" }
];

const KingdomButtonPage = ({ onKingdomSelect }) => {
  const handleClick = useCallback(async () => {
    try {
      await Haptics.impact({ style: ImpactStyle.Light });
    } catch (error) {
      // Haptics not available
    }
    if (onKingdomSelect) {
      onKingdomSelect();
    }
    window.scrollTo(0, 0);
  }, [onKingdomSelect]);

  return (
    <div className="kingdom-page">
      <Container fluid className="kingdom-container">
        <Row className="justify-content-center g-3">
          {KINGDOMS_DATA.map(kingdom => (
            <Col key={kingdom.name} xs={6} sm={6} md={3} className="d-flex justify-content-center">
              <Link 
                to={kingdom.path}
                onClick={handleClick}
                className="kingdom-link"
              >
                <Button className="kingdom-button">
                  <Image 
                    src={kingdom.flag} 
                    alt={`${kingdom.name} Flag`}
                    className="kingdom-flag"
                  />
                  <span className="kingdom-name">{kingdom.name}</span>
                </Button>
              </Link>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
};

export default KingdomButtonPage;